export const NODE_STATUS_STARTING_MAINTENANCE = 'starting maintenance';
export const NODE_STATUS_UNDER_MAINTENANCE = 'under maintenance';
export const NODE_STATUS_STOPPING_MAINTENANCE = 'stopping maintenance';

// t('metal3-plugin~Starting maintenance')
// t('metal3-plugin~Under maintenance')
// t('metal3-plugin~Stopping maintenance')

export const NODE_STATUS_TITLE_KEYS = {
  [NODE_STATUS_STARTING_MAINTENANCE]: 'metal3-plugin~Starting maintenance',
  [NODE_STATUS_UNDER_MAINTENANCE]: 'metal3-plugin~Under maintenance',
  [NODE_STATUS_STOPPING_MAINTENANCE]: 'metal3-plugin~Stopping maintenance',
};
